import { INotification } from '../types/BaseTypes';

export default class Notification {
  static showError: INotification['showError'] = () => {};
  static showSuccess: INotification['showSuccess'] = () => {};
  static showSomethingWrongError: INotification['showSomethingWrongError'] = () => {};

  static init = (notificationInstance: INotification) => {
    Notification.showError = notificationInstance.showError;
    Notification.showSuccess = notificationInstance.showSuccess;
    Notification.showSomethingWrongError = notificationInstance.showSomethingWrongError;
  };
}
